import { useEffect } from "react";
import { initAnalytics } from "@/services/firebase/analytics.service";

/** Initializes Firebase Analytics once on app load. */
export function AnalyticsBootstrap() {
  useEffect(() => {
    void initAnalytics();
  }, []);

  return null;
}
